<template>
  <div>
    <b-row class="steps">
      <b-col lg="9" sm="9" md="9" cols="9" align="left">
        <p class="step-name">{{ stepName }}</p>
      </b-col>
      <b-col lg="3" sm="3" md="3" cols="3" align="right">
        <p class="step-name">{{ step }}/4</p>
      </b-col>
    </b-row>
    <b-row class="row px-lg-0 px-3">
      <b-col class="delete-progress-bar px-0">
        <div :style="{ width: steps + '%', transition: 'width 2s' }"></div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import i18n from "../../i18n";
export default {
  name: "DeleteAccountProgressBar",
  data() {
    return {
      step: 1,
      stepName: i18n.t("deleteAccount")
    };
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property,consistent-return
    steps() {
      if (this.$route.query.q === "check") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.step = 2;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.stepName = i18n.t("confirmAccount");
        return "50";
      }
      if (this.$route.query.q === "confirmation") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.step = 3;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.stepName = i18n.t("finalConfirmation");
        return "75";
      }
      if (this.$route.query.q === "close") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.step = 4;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.stepName = i18n.t("accountDeleted");
        return "100";
      }
      return "25";
    },
    viewName() {
      if (this.$route.query.q === "check") {
        return "Check account information";
      }
      if (this.$route.query.q === "confirmation") {
        return "Confirmation";
      }
      if (this.$route.query.q === "close") {
        return "Account was closed";
      }
      return "Close your Trebel account?";
    }
  }
};
</script>

<style scoped></style>
